import React from 'react';
import styled from './styled';
import { TouchableWithoutFeedback } from '../web/react-native';
import Icon from './Icon';

import * as Colors from '../helpers/Colors';

interface SelectableRowProps {
  title: string;
  subtitle?: string;
  isSelected: boolean;
  onSelection(): void;
}

const SelectableRow: React.FC<SelectableRowProps> = ({
  title,
  subtitle,
  isSelected,
  onSelection,
}) => {
  return (
    <TouchableWithoutFeedback onPress={onSelection}>
      <Container>
        <TextContainer>
          <Title>{title}</Title>
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
        </TextContainer>
        {isSelected && <Checkmark name="check" size={20} color={Colors.primary} />}
      </Container>
    </TouchableWithoutFeedback>
  );
};

export default SelectableRow;

const Container = styled.View`
  flex-direction: row !important;
  padding: 10px 5px;
  justify-content: space-between;
  align-items: center;
  border-bottom-width: 1px;
  border-bottom-color: #ccc;
`;

const TextContainer = styled.View`
  flex: 1;
  flex-direction: row !important;
  justify-content: space-between;
`;

const Checkmark = styled(Icon)``;

const Title = styled.Text`
  flex-wrap: wrap;
  font-size: 15px;
  color: ${Colors.primaryText};
`;

const Subtitle = styled.Text`
  flex-wrap: wrap;
  font-size: 14px;
  color: ${Colors.secondaryText};
`;
